import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { Icon } from "@iconify/react";
import { IconButtonStyle } from "@/views/CommonComponent/Styled/CommonBackStyled";
import { HeaderContainer } from "../Styled/SettingSubpageHeaderStyled";

function SettingSubpageHeader(props) {
  const { onBack, title, description, showBackButton } = props;

  return (
    <HeaderContainer>
      {showBackButton ? (
        <IconButtonStyle onClick={onBack}>
          <Icon icon="material-symbols:arrow-back-ios-rounded" />
        </IconButtonStyle>
      ) : null}
      <Box
        sx={{
          width: "100%",
          boxSizing: "border-box",
          background: "unset",
        }}
      >
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bolder", whiteSpace: "pre-line" }}>
          {title}
        </Typography>
        {description ? <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>{description}</Typography> : null}
      </Box>
    </HeaderContainer>
  );
}

SettingSubpageHeader.propTypes = {
  onBack: PropTypes.func,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  showBackButton: PropTypes.bool,
};

SettingSubpageHeader.defaultProps = {
  onBack: () => {},
  description: null,
  showBackButton: true,
};

export default React.memo(SettingSubpageHeader);
